/**
 * Determines the expense title that will be displayed
 *
 * @param {object} expense The expense for which the title is extracted
 * @returns {string} title - the title that is used for display purposes
 */

export const getExpenseTitle = (expense = {}) =>
  expense.title ||
  expense.merchantName ||
  `Expense #${expense.expenseId || expense.id}`

/**
 * Given a product type
 * returns boolean false if product type is FIXED_INDEMNITY or  true in other cases
 *
 * @param {string} productType
 * @returns {bool}
 */
export const isMajorMedicalProduct = (productType = '') =>
  productType !== 'FIXED_INDEMNITY'

/**
 * Given a product type
 * returns boolean true if product type is ASO or GFI
 *
 * @param {string} productType
 * @returns {bool}
 */
export const isGroupProduct = (productType = '') =>
  productType === 'ASO' || productType === 'GFI'
